import * as React from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import { DateParam } from '@avcan/utils/params'
import isToday from 'date-fns/is_today'
import * as URLUtils from '@avcan/utils/url'

const context = React.createContext()

Provider.propTypes = {
    document: PropTypes.object,
    tutorial: PropTypes.object.isRequired,
}

export function Provider({ forecast, tutorial, children }) {
    const router = useRouter()
    const value = React.useMemo(() => {
        let date = new Date()

        if (forecast?.date) {
            const [year, month, day] = forecast.date.split('-').map(Number)

            date = new Date(year, month - 1, day, 12)
        }

        return {
            onDateChange(date) {
                const path = createPath(date)

                router.push(path)
            },
            prefetch(date) {
                const path = createPath(date)

                router.prefetch(path)
            },
            forecast,
            tutorial,
            date,
        }
    }, [forecast, router, tutorial])

    return <context.Provider value={value}>{children}</context.Provider>
}

export function useContext() {
    return React.useContext(context)
}

// Utils
function createPath(date) {
    const dateAsString = isToday(date) ? undefined : DateParam.format(date)

    return URLUtils.buildPath('/weather', 'forecast', dateAsString)
}
